import { render, staticRenderFns } from "./SendMessageDialog.vue?vue&type=template&id=34c580a4&scoped=true"
import script from "./SendMessageDialog.vue?vue&type=script&lang=ts"
export * from "./SendMessageDialog.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageDialog.vue?vue&type=style&index=0&id=34c580a4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c580a4",
  null
  
)

export default component.exports